import React from "react";
import { isApiFileUrl, resolveFileUrl } from "../../utils/fileUrl";

type AppImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src" | "crossOrigin"
> & {
  src?: string | null;
};

const AppImage: React.FC<AppImageProps> = ({ src, ...rest }) => {
  const resolved = resolveFileUrl(src);
  const crossOrigin = isApiFileUrl(resolved) ? "use-credentials" : undefined;
  return <img src={resolved} crossOrigin={crossOrigin} {...rest} />;
};

export default AppImage;
